import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {Button} from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {createLoginUrl} from './index';

const LoginPrompt = () => {
    // Vorbelegung des locale für Login/Registierung über Keycloak ist eine best-effort Geschichte, denn wenn der
    // Benutzer bereits auf einem Keycloak Screen gewesen war und dort aktiv eine Sprache ausgewählt hatte, so wird
    // dies per Cookie vermerkt und die Auswahl die wir hier mitsenden wird dann ignoriert.
    const intl = useIntl();

    return (
        <Container>
            <Row>
                <Col>
                    <p>
                        <FormattedMessage id="login.prompt.text"/>
                    </p>
                    <Button href={createLoginUrl({locale: intl.locale})}>
                        <FormattedMessage id="login.prompt.button.login.label"/>
                    </Button>


                    <Button className="ml-1" href={createLoginUrl({
                        action: 'register',
                        locale: intl.locale
                    })}>
                        <FormattedMessage id="login.prompt.button.register.label"/>
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginPrompt;
